import React from 'react';
import { motion, Variants } from 'motion/react';
import { cn } from '../lib/utils';

interface SignatureRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  distance?: number;
}

export const SignatureReveal: React.FC<SignatureRevealProps> = ({ 
  children, 
  className
}) => {
  return (
    <div className={cn(className)}>
      {children}
    </div>
  );
};

export const MagneticEffect: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const { clientX, clientY, currentTarget } = e;
    const { left, top, width, height } = currentTarget.getBoundingClientRect();
    const x = (clientX - (left + width / 2)) / 15;
    const y = (clientY - (top + height / 2)) / 15;
    setPosition({ x, y });
  };

  const handleMouseLeave = () => {
    setPosition({ x: 0, y: 0 });
  };

  return (
    <motion.div
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: position.x, y: position.y }}
      transition={{ type: 'spring', stiffness: 150, damping: 15, mass: 0.1 }}
      className={cn("relative", className)}
    >
      {children}
    </motion.div>
  );
};

export const TiltCard: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  const [rotateX, setRotateX] = React.useState(0);
  const [rotateY, setRotateY] = React.useState(0);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (typeof window !== 'undefined' && window.innerWidth < 768) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    // Calculate rotation based on mouse position
    // Max rotation is 15 degrees
    const rotateYValue = ((mouseX - width / 2) / width) * 30; 
    const rotateXValue = ((height / 2 - mouseY) / height) * 30;
    
    setRotateX(rotateXValue);
    setRotateY(rotateYValue);
  };

  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };

  return (
    <motion.div
      style={{ perspective: 1000 }}
      className={cn("relative", className)}
    >
      <motion.div
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        animate={{ rotateX, rotateY }}
        transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        style={{ transformStyle: 'preserve-3d' }}
        className="h-full w-full"
      >
        <div style={{ transform: 'translateZ(40px)' }} className="h-full w-full">
          {children}
        </div>
      </motion.div>
    </motion.div>
  );
};
